import { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/wedding/Navbar";
import Footer from "@/components/wedding/Footer";
import RSVP from "@/components/wedding/RSVP";

const RsvpContext = createContext({ openRsvp: () => {} });
export const useRsvp = () => useContext(RsvpContext);

export default function Layout() {
  const [open, setOpen] = useState(false);
  return (
    <RsvpContext.Provider value={{ openRsvp: () => setOpen(true) }}>
      <div className="App min-h-screen flex flex-col">
        <Navbar onOpenRsvp={() => setOpen(true)} />
        <main className="flex-1 pt-16 sm:pt-20">
          <Outlet />
        </main>
        <Footer />
        <RSVP open={open} setOpen={setOpen} />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#4A1018",
              color: "#FBF5EA",
              border: "1px solid #4A1018",
              borderRadius: "2px",
              fontFamily: "Outfit, sans-serif",
              letterSpacing: "0.04em",
            },
          }}
        />
      </div>
    </RsvpContext.Provider>
  );
}
